/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ContactScriptManifest } from './ContactScriptManifest.js';
import {
    ContactScriptManifestFromJSON,
    ContactScriptManifestFromJSONTyped,
    ContactScriptManifestToJSON,
} from './ContactScriptManifest.js';

/**
 * 
 * @export
 * @interface UpdateContactScriptResponse
 */
export interface UpdateContactScriptResponse {
    /**
     * 
     * @type {ContactScriptManifest}
     * @memberof UpdateContactScriptResponse
     */
    data?: ContactScriptManifest;
    /**
     * 
     * @type {number}
     * @memberof UpdateContactScriptResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateContactScriptResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateContactScriptResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof UpdateContactScriptResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the UpdateContactScriptResponse interface.
 */
export function instanceOfUpdateContactScriptResponse(value: object): boolean {
    return true;
}

export function UpdateContactScriptResponseFromJSON(json: any): UpdateContactScriptResponse {
    return UpdateContactScriptResponseFromJSONTyped(json, false);
}

export function UpdateContactScriptResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateContactScriptResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ContactScriptManifestFromJSON(json['data']),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function UpdateContactScriptResponseToJSON(value?: UpdateContactScriptResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': ContactScriptManifestToJSON(value['data']),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

